import request from '#/utils/request';
import { keysToCamel, normalizeListPage } from '#/api/adapters/wireCase';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

/**
 * 巢狀 stock-receipt list：空 listQuery 可不送 page／page_size。
 * 有 page／pageSize／keyword／sort／filters 任一實際值才帶 params。
 *
 * @param {object} [listQuery]
 * @returns {boolean}
 */
function hasNestedListQueryParams(listQuery = {}) {
  if (listQuery.page != null || listQuery.pageSize != null) {
    return true;
  }
  if (listQuery.keyword) {
    return true;
  }
  if (Array.isArray(listQuery.sort) && listQuery.sort.length > 0) {
    return true;
  }
  if (listQuery.filters && Object.keys(listQuery.filters).length > 0) {
    return true;
  }
  return false;
}

/**
 * GET /srm/purchase-order/{poId}/stock-receipt
 *
 * 後端可能回傳無 page 的 list；若 page 缺失則以空物件正規化。
 * 巢狀預設不送 list query（`listQuery = {}`）。
 */
export async function fetchPurchaseOrderStockReceiptList(poId, listQuery = {}) {
  const requestConfig = hasNestedListQueryParams(listQuery)
    ? { params: listQueryToApiParams(listQuery) }
    : undefined;

  const { data: raw } = await request.get(
    `/srm/purchase-order/${poId}/stock-receipt`,
    requestConfig,
  );
  return {
    message: raw.message,
    route: raw.route,
    data: keysToCamel(raw.list ?? []),
    page: normalizeListPage(raw.page ?? {}),
  };
}
